import React from 'react';
// import {Link, IndexLink} from 'react-router';
import {Link, NavLink} from 'react-router-dom';
import {Collapse} from 'reactstrap';


// icons
import IconDashboard from 'react-icons/lib/md/dashboard';
import IconFileTextO from 'react-icons/lib/fa/file-text-o';
import IconTable from 'react-icons/lib/fa/table';
import IconCreditCardAlt from 'react-icons/lib/fa/credit-card-alt';
import IconCog from 'react-icons/lib/fa/cog';
import IconDown from 'react-icons/lib/md/chevron-right';
import Iconbar from 'react-icons/lib/fa/barcode';
import ScrollArea from '../scrollbar';
import IconCalendar from 'react-icons/lib/fa/calendar'

import './style.css';
import logo from  './logo.png';


const NavHead = (props) => (
    <header className="nav-head">
        <NavLink to="/">
            <figure className="figure-140">
                <img src={logo} alt="Maxicomm" />
            </figure>
        </NavLink>
      {/*  <div className={`toggle-dot active`} onClick={props.toggleNav}></div>*/}
    </header>
);

class NavList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: 0

        }
    }

    handleClick = (index, e) => {
        let c = e.currentTarget.className;
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            selected: this.state.selected === index ? '' : index
        })

        
    }
    handleOpen = (index, e) => {
        e.stopPropagation();
        this.setState({
            selected: index
        })
    }

    render() {
        
      
         let rol= 1;//parseInt(this.props.user.rol,10);
         let articulos=0;
         // console.log('permisos--->',this.props.permisos)
         if (typeof(this.props.user) !="undefined")
        {
             
            rol= parseInt(this.props.user.rol);
       

        }rol=4;

         if(Object.keys(this.props.permisos).length > 0){
            articulos= parseInt(this.props.permisos[0].menu);
             console.log('permisos--->',this.props.permisos);
        }

        /**Codigo eventos contaq menu**/

        let rolEvent = 0;

        let departamentoEvent = 0;

        rolEvent = this.props.user? this.props.user.rol : 0;

        departamentoEvent = this.props.user? this.props.user.departamento : 0;

        /**fin Codigo eventos contaq menu**/
        

        return <ScrollArea className="nav-list-container" horizontal={false} verticalScrollbarStyle={{width: '4px', marginLeft: '10px'}}>
            <ul className="list-unstyled nav-list clearfix">
                <li><div className="nav-list-title">Menu</div></li>
                <li>
                    <NavLink exact to="/" activeClassName="active">
                        <IconDashboard size="18" className="icon-dashboard"/>
                        <span className="name">Dashboard</span>
                    </NavLink>
                </li>
                <li className={(this.state.selected === 6) ? 'selected': ''}>
                    <Link to="" onClick={this.handleClick.bind(this, 6)}>
                        <IconFileTextO size="18" />
                        <span className="name">Tickets</span>
                        <IconDown size="14" className="icon-down"/>
                    </Link>
                    <Collapse isOpen={(this.state.selected === 6) ? true : false} onClick={this.handleOpen.bind(this, 6)}>
                        <ul className="inner-drop list-unstyled">
                            <li ><NavLink to="/old_tickets"  activeClassName="active" >Historicos</NavLink></li>
                            <li ><NavLink replace to="/tickets"   activeClassName="active" >Nuevos</NavLink></li>
                             { rol>1&& 
                                <li ><NavLink replace to="/insidencias"   activeClassName="active" >Insidencias</NavLink></li>
                             }
                        </ul>
                    </Collapse>
                </li>
                {/*<li onClick={this.handleClick.bind(this, 1)} className={(this.state.selected === 1) ? 'selected': ''}>
                    <NavLink exact to="/app/tickets" activeClassName="active">
                        <IconFileTextO size="18" />
                        <span className="name">Tickets</span>
                    </NavLink>
                </li>
                <li onClick={this.handleClick.bind(this, 5)} className={(this.state.selected === 5) ? 'selected': ''}>
                    <NavLink to="/app/ticket_v2" activeClassName="active">
                        <IconTable size="18" />
                        <span className="name">Tickets v2</span>
                    </NavLink>
                </li>*/}
                { rol>2&&
                <li onClick={this.handleClick.bind(this, 2)} className={(this.state.selected === 2) ? 'selected': ''}>
                    <NavLink exact to="/facturacion" activeClassName="active">
                        <IconCreditCardAlt size="18" />
                        <span className="name">Facturación</span>
                    </NavLink>
                </li>
                }
                <li onClick={this.handleClick.bind(this, 3)} className={(this.state.selected === 3) ? 'selected': ''}>
                    <NavLink to="/reportes" activeClassName="active">
                        <IconTable size="18" />
                        <span className="name">Reportes</span>
                    </NavLink>
                </li>
                <li className={(this.state.selected === 4) ? 'selected': ''}>
                    <Link to="" onClick={this.handleClick.bind(this, 4)}>
                        <IconCog size="18"/>
                        <span className="name">Config</span>
                        <IconDown size="14" className="icon-down"/>
                    </Link>
                    <Collapse isOpen={(this.state.selected === 4) ? true : false} onClick={this.handleOpen.bind(this, 4)}>
                        <ul className="inner-drop list-unstyled">
                           { rol>2&&
                              <li><NavLink to="/usuarios" activeClassName="active">Usuarios</NavLink></li>
                           }
                            <li><NavLink to="/clientes" activeClassName="active">Clientes</NavLink></li>
                            { rol>2&&
                            <li><NavLink to="/departamentos" activeClassName="active">Departamentos</NavLink></li>
                            }
                            { rol>2&&
                         <li><NavLink to="/descuentos" activeClassName="active">Descuentos</NavLink></li>
                            }
                        </ul>
                    </Collapse>
                </li>
                {articulos==1&&
                    <li className={(this.state.selected === 5) ? 'selected': ''}>
                    <Link to="" onClick={this.handleClick.bind(this, 5)}>
                        <Iconbar size="18"/>
                        <span className="name">Inventario</span>
                        <IconDown size="14" className="icon-down"/>
                    </Link>
                    <Collapse isOpen={(this.state.selected === 5) ? true : false} onClick={this.handleOpen.bind(this, 5)}>
                        <ul className="inner-drop list-unstyled">
                            <li><NavLink to="/inventario" activeClassName="active">Productos</NavLink></li>
                            <li><NavLink to="/categorias" activeClassName="active">Categorias</NavLink></li>
                           
                        </ul>
                    </Collapse>
                </li>

                }

                { (rolEvent==4 || departamentoEvent== 11 || departamentoEvent == 2)&&
                <li onClick={this.handleClick.bind(this, 7)} className={(this.state.selected === 7) ? 'selected': ''}>
                    <NavLink exact to="/eventos" activeClassName="active">
                        <IconCalendar size="18" />
                        <span className="name">EVENTOS</span>
                    </NavLink>
                </li>
                }
                    


                

                
                {/*<li><div className="nav-list-title">Reportes</div></li>*/}
                {/*<li onClick={this.handleClick.bind(this, 3)} className={(this.state.selected === 3) ? 'selected': ''}>
                    <NavLink to="">
                        <IconUI size="18"/>
                        <span className="name">Elements</span>
                        <IconDown size="14" className="icon-down"/>
                    </NavLink>
                    <Collapse isOpen={this.state.selected === 3 ? true: false} onClick={this.handleOpen.bind(this, 3)}>
                        <ul className="inner-drop list-unstyled">
                            <li><NavLink to="/ui/buttons" activeClassName="active">Buttons</NavLink></li>
                            <li><NavLink to="/ui/typography" activeClassName="active">Typography</NavLink></li>
                            <li><NavLink to="/ui/cards" activeClassName="active">Cards</NavLink></li>
                            <li><NavLink to="/ui/modals" activeClassName="active">Modals</NavLink></li>
                            <li><NavLink to="/ui/notification" activeClassName="active">Notification</NavLink></li>
                            <li><NavLink to="/ui/extras" activeClassName="active">Extras</NavLink></li>
                        </ul>
                    </Collapse>
                </li>
                <li onClick={this.handleClick.bind(this, 4)} className={(this.state.selected === 4) ? 'selected': ''}>
                    <NavLink to="">
                        <IconForm size="18"/>
                        <span className="name">Forms</span>
                        <IconDown size="14" className="icon-down"/>
                    </NavLink>
                    <Collapse isOpen={(this.state.selected === 4) ? true : false} onClick={this.handleOpen.bind(this, 4)}>
                        <ul className="inner-drop list-unstyled">
                            <li><NavLink to="/forms/general" activeClassName="active">General</NavLink></li>
                            <li><NavLink to="/forms/advanced" activeClassName="active">Advanced</NavLink></li>
                        </ul>
                    </Collapse>
                </li>
                <li onClick={this.handleClick.bind(this, 5)} className={(this.state.selected === 5) ? 'selected': ''}>
                    <NavLink to="/charts" activeClassName="active">
                        <IconChart size="18"/>
                        <span className="name">Charts</span>
                        &emsp;<span className="badge badge-primary badge-chart text-uppercase">mixed</span>
                    </NavLink>
                </li>
                <li onClick={this.handleClick.bind(this, 6)} className={(this.state.selected === 6) ? 'selected': ''}>
                    <NavLink to="/tables" activeClassName="active">
                        <IconTable size="18"/><span className="name">Tables</span>
                    </NavLink>
                </li>
                <li className={(this.state.selected === 7) ? 'selected': ''}>
                    <Link to="" onClick={this.handleClick.bind(this, 7)}>
                        <IconPages size="18"/>
                        <span className="name">Pages</span>
                        <IconDown size="14" className="icon-down"/>
                    </Link>
                    <Collapse isOpen={(this.state.selected === 7) ? true : false} onClick={this.handleOpen.bind(this, 7)}>
                        <ul className="inner-drop list-unstyled">
                            <li><NavLink to="/pages/signin" activeClassName="active">Sign In</NavLink></li>
                            <li><NavLink to="/pages/register" activeClassName="active">Register</NavLink></li>
                            <li><NavLink to="/pages/forget" activeClassName="active">Forget Pass</NavLink></li>
                            <li><NavLink to="/pages/404" activeClassName="active">404</NavLink></li>
                            <li><NavLink to="/pages/invoice" activeClassName="active">Invoice</NavLink></li>
                        </ul>
                    </Collapse>
                </li>*/}
            </ul>
        </ScrollArea>
    }
}




export default (props) => (
    <nav className={`site-nav ${props.mini ? 'mini' : ''}`}>
        <NavHead {...props}/>
            <NavList user={props.user} permisos={props.permisos}/>

    </nav>
);



// WEBPACK FOOTER //
// ./src/shared/components/nav/index.js